import {organizationConstants} from '_constants';

const INITIAL_STATE = {
    loading: true,
    error: '',
    lastUpdatedHandleId: null
};

export function salesforceOrgConfigReducer(state = INITIAL_STATE, action) {
    switch (action.type) {

        case organizationConstants.GET_SALESFORCE_ORG_CONFIG_REQUEST:
            return {...state, loading: true, error: '', lastUpdatedHandleId: action.handleId};
        case organizationConstants.GET_SALESFORCE_ORG_CONFIG_SUCCESS:
            return {...state, dataSourceHandles: action.payload, loading: false};
        case organizationConstants.GET_SALESFORCE_ORG_CONFIG_FAILURE:
            return {...state, error: action.error, loading: false};

        default:
            return state
    }
}
